import { z } from 'zod';

export const zodInvoiceV2AssigneeSuggestionsQueryParamsSchema = z.object({
  limit: z.number().int().min(1).max(500).optional(),
  offset: z.number().int().min(0).optional(),
  searchString: z.string().trim().optional(),
});
